import axios from 'axios'
import { system } from '@/api/system.js'

/**
 * 独立 axios 实例：仅挂 Authorization，不走 http.js 的全局 loading 拦截器。
 * 埋点上报为后台静默请求，不应阻塞页面 UI。
 */
const trackHttp = axios.create({
  timeout: 30000,
  withCredentials: false,
  headers: { 'Content-Type': 'application/json;charset=utf-8' }
})

trackHttp.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('access_token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  (error) => Promise.reject(error)
)

/**
 * 批量上报埋点事件
 * @param {Array} events TrackEventDto 列表
 * @returns {Promise} CommonResult<{ pageVisitIds }>
 */
export function report(events) {
  return trackHttp
    .post(system.requestBaseUrl + system.cssServerName + '/track/report', { events })
    .then((res) => res.data)
}



// WEBPACK FOOTER //
// ./src/api/track.js